import React from 'react'
import { Sidebar } from 'semantic-ui-react'
import styled from 'styled-components'

import { DesktopMenu, MobileMenu } from './Menu/Menu'
import AdminRoutes from './AdminRoutes'
import Loader from '../Shared/Loader'

const Wrapper = styled.div`
    max-width: 800px;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 40px;
    padding: 10px;
`

const AdminLayout = ({ loading }) => (
    <Sidebar.Pushable>

        <MobileMenu />

        <Sidebar.Pusher>

            <DesktopMenu />

            <Wrapper>

                {!loading ? null : <Loader />}

                <AdminRoutes />

            </Wrapper>

        </Sidebar.Pusher>

    </Sidebar.Pushable>
)

export default AdminLayout


// WEBPACK FOOTER //
// ./src/Admin/AdminLayout.js